import React, { useState } from 'react';

function Sort({ setSortOption }) {
    const [activeSort, setActiveSort] = useState('recommended');

    const handleSortChange = (option) => {
        setActiveSort(option);
        setSortOption(option);
    };

    return (
        <div className="sort-options">
            <button 
                className={`sort-button ${activeSort === 'recommended' ? 'active' : ''}`} 
                onClick={() => handleSortChange('recommended')}
            >
                Odporúčané
            </button>
            <button 
                className={`sort-button ${activeSort === 'closest' ? 'active' : ''}`} 
                onClick={() => handleSortChange('closest')}
            >
                Najbližšie
            </button>
            <button 
                className={`sort-button ${activeSort === 'highestRated' ? 'active' : ''}`} 
                onClick={() => handleSortChange('highestRated')}
            >
                Najlepšie
            </button>
        </div>
    );
}

export default Sort;
